import type { Area, Level, MyPermissions } from "./permissions";

// A mirror of the React Query cache for /v1/users/me/permissions, kept here so
// the transport layer can read it. React Query stays the source of truth; this
// is only ever written from the hook that owns that query.
let snapshot: MyPermissions | null = null;

export const setPermissionsSnapshot = (value: MyPermissions | null) => {
  snapshot = value;
};

/**
 * The known level for an area, or null when permissions haven't loaded yet.
 * Callers must treat null as "don't know" and let the server decide.
 */
export function knownLevel(area: Area): Level | null {
  return snapshot?.permissions[area] ?? null;
}
